
import { memo } from 'react';
import { Bar } from 'react-chartjs-2';
import { Typography } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement
);


const ChartBar = (props) => {

  const { data, onClick } = props;

  const handleChartClick = (evt, elements) => {
    if (elements.length > 0) {
      const clickedIndex = elements[0].index;
      const clickedLabel = data.labels[clickedIndex];
      let value = data?.datasets[0]?.data[clickedIndex]
      onClick && onClick(clickedLabel, value)
    }
  };

  const option = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: data?.legend,
        position: "bottom",

      },
      title: {
        display: true,
        text: data.unit,
        position: "left"
      },
      tooltip: {
        enabled: true,
        usePointStyle: true,
        callbacks: {
          title: (datas) => {
            return datas[0].dataset.label
          },
          label: (datas) => {
            if (data.type === "VidFleetFirmware") {
              let value = (datas.raw % 1 !== 0) ? Number(datas.raw).toFixed(2) : datas.raw;
              return `Total ${value}`
            } else {
              let percentage = (data.percentage) ? '%' : '';
              let value = (datas.raw % 1 !== 0) ? Number(datas.raw).toFixed(2) : datas.raw;
              return ` ${datas.label} ${value} ${percentage}`
            }
          }
        },
      }
    },
    onClick: handleChartClick
  };

  return (
    <>
      <div className="title_chart">
        <Typography className="content-text" variant="h6" style={{ fontSize: '1.15rem' }}>
          {data.title}
        </Typography>
        <Typography className="content-text" style={{ fontSize: '0.9 rem' }}>
          {data.subTitle}
        </Typography>
      </div>
      <div className="body_chart">
        {
          <Bar data={data} options={option} />
        }
      </div>
    </>
  );
}

export default memo(ChartBar);